import React from 'react';
import { X } from 'lucide-react';
import { productColorOptions } from '../../utils/colors';

const AddProductModal = ({
    show,
    onClose,
    newProduct,
    setNewProduct,
    onSave,
    groups
}) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50">
            <div className="bg-gray-900 rounded-xl border border-gray-800 w-full max-w-md">
                <div className="p-6 border-b border-gray-800 flex items-center justify-between">
                    <h2 className="text-2xl font-bold">Add New Product</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-white transition-colors"
                    >
                        <X className="w-6 h-6" />
                    </button>
                </div>

                <div className="p-6 space-y-4">
                    <div>
                        <label className="block text-sm font-medium mb-2">Product ID</label>
                        <input
                            type="text"
                            value={newProduct.id}
                            onChange={(e) => setNewProduct({ ...newProduct, id: e.target.value })}
                            placeholder="nexus-api-gateway"
                            className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white"
                        />
                        <p className="text-gray-400 text-xs mt-1">Format: letters, numbers, hyphens, underscores (e.g., nexus-api-gateway, unidash-1)</p>
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-2">Product Name</label>
                        <input
                            type="text"
                            value={newProduct.name}
                            onChange={(e) => setNewProduct({ ...newProduct, name: e.target.value })}
                            placeholder="My Product"
                            className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-2">Description (Optional)</label>
                        <textarea
                            value={newProduct.description}
                            onChange={(e) => setNewProduct({ ...newProduct, description: e.target.value })}
                            placeholder="Product description"
                            rows={3}
                            className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white resize-none"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-2">Color</label>
                        <select
                            value={newProduct.color}
                            onChange={(e) => setNewProduct({ ...newProduct, color: e.target.value })}
                            className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white"
                        >
                            {productColorOptions.map((color) => (
                                <option key={color.value} value={color.value}>
                                    {color.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-2">Version URL (Optional)</label>
                        <input
                            type="url"
                            value={newProduct.version_url}
                            onChange={(e) => setNewProduct({ ...newProduct, version_url: e.target.value })}
                            placeholder="https://example.com/api/_version"
                            className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white"
                        />
                        <p className="text-gray-400 text-xs mt-1">URL to check live deployment version</p>
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-2">Group <span className="text-red-400">*</span></label>
                        <select
                            value={newProduct.group_id || ''}
                            onChange={(e) => setNewProduct({ ...newProduct, group_id: e.target.value ? parseInt(e.target.value) : null })}
                            className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white"
                            required
                        >
                            <option value="">Select a group</option>
                            {groups && groups.map((group) => (
                                <option key={group.id} value={group.id}>
                                    {group.name}
                                </option>
                            ))}
                        </select>
                        <p className="text-gray-400 text-xs mt-1">Assign product to a group for easier filtering</p>
                    </div>
                </div>

                <div className="p-6 border-t border-gray-800 flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-6 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors font-medium"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onSave}
                        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                    >
                        Save Product
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddProductModal;
